import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { fetchLawyerPricing, fetchLawyerPricingHistory } from "@lawyer/services/lawyerApi";
import LevelRequestForm from "@lawyer/components/LevelRequestForm";
import LevelHistoryCard from "@lawyer/components/LevelHistoryCard";

export default function LawyerPricing() {
  const [data, setData] = useState(null);

  // Level history is independent of the pricing payload — prefetched concurrently on first load only;
  // later reloads let LevelHistoryCard refresh itself via refreshKey (approved_at change).
  const [history, setHistory] = useState(undefined);
  const load = async () => {
    const first = history === undefined;
    const historyP = first ? fetchLawyerPricingHistory().then((d) => ({ entries: d?.entries || [] })).catch(() => null) : null;
    try {
      const d = await fetchLawyerPricing();
      setData(d);
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not load pricing"); }
    if (historyP) setHistory(await historyP);
  };
  useEffect(() => { load(); }, []);

  if (!data) return <div className="text-slate-500" data-testid="lawyer-pricing-loading">Loading…</div>;

  return (
    <>
      <div className="mb-6" data-testid="lawyer-pricing-header">
        <h1 className="text-2xl sm:text-3xl font-extrabold text-[#0A2540]" style={{ fontFamily: "Poppins" }}>Pricing Level</h1>
        <p className="text-sm text-slate-500 mt-1">Your professional fee level. Level changes require Admin approval.</p>
      </div>

      <div className="space-y-4 max-w-3xl">
        <LevelRequestForm data={data} setData={setData} onSubmitted={load} />
        {history !== undefined && <LevelHistoryCard refreshKey={data?.active?.approved_at || "none"} initialState={history} />}
      </div>
    </>
  );
}
